import { MessageFormatter } from '@shared/hooks/intl';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { isInContextEditorEnabled } from './helpers';

const tolgeeTranslate = isInContextEditorEnabled()
  ? { t: null as null | typeof import('@shared/lib/tolgee/TolgeeProvider')['tolgee']['t'] }
  : null;

const useTolgeeFormatMessage = () => {
  const { formatMessage } = useIntl();
  const tolgeeT = tolgeeTranslate?.t;
  if (tolgeeTranslate && !tolgeeT) {
    import('@shared/lib/tolgee/TolgeeProvider').then(({ tolgee }) => {
      tolgeeTranslate.t = tolgee.t;
    });
  }

  return useCallback<MessageFormatter>(
    (id: string, values?: any, defaultMessage?: string) =>
      tolgeeT ? tolgeeT(id, values) : formatMessage({ id, defaultMessage }, values),
    [formatMessage, tolgeeT],
  );
};

export default useTolgeeFormatMessage as typeof useTolgeeFormatMessage | null;
